import "./App.css";
import AllListedItems from "./components/allItems.js";
import Home from "./components/home.js";
import MyItems from "./components/myItems.js";
import MyItemsCryo from "./components/myItemsCryo.js";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useToken } from "./components/useToken";
import Login from "./components/Login.js";
import CreateAccountForm from "./components/SignUp.js";
import LogoutButton from "./components/Logout.js";
import CreateItemForm from "./components/itemForm.js";
import CreateTypesForm from "./components/typesForm.js";
import CreateEventForm from "./components/eventForm.js";
import CreateMapsForm from "./components/mapsForm.js";
import CreateGamesForm from "./components/gamesForm.js";
import CreateMapsNameForm from "./components/mapsNameForm.js";
import Paintings from "./components/paintings.js";
import Locations from "./components/locations.js";
import PaintingSolver from "./components/PaintingSolver.js";
import LightsOut from "./components/LightsOut.js";
import LightsOutSolver from "./components/LightsOutSolver.js";
import EditItemForm from "./components/editItemForm.js";
import SliderGame from "./components/sliderGame.js";
import Tickets from "./components/tickets.js";
import FriendSearch from "./components/FriendSearch.js";
import AllAccounts from "./components/allAccounts.js";
import AccountSettings from "./components/editProfManage.js";
import MyProfile from "./components/myProfile.js";
import EditMyAccount from "./components/editProfile.js";
import AllJunk from "./components/allJunk.js";
import Monster from "./components/Monsters.js";
import Puzzle from "./components/Puzzles.js";
import FriendList from "./components/friendItems.js";
import Grid from "./components/memoryGrid.js";
import StatsItems from "./components/StatsPage.js";
import MyItemsV2 from "./components/myItemsV2.js";
import SubmitTranslations from "./components/SubmitTranslations.js";
import ReviewTranslations from "./components/ReviewTranslations.js";
import SubmitSuggestion from "./components/SubmitSuggestion.js";
import ReviewSuggestions from "./components/ReviewSuggestions.js";
import ManageAnnouncements from "./components/ManageAnnouncements.js";
import TrustedClaimers from "./components/TrustedClaimers.js";
import ReviewClaims from "./components/ReviewClaims.js";
import ManageUnlockRequirements from "./components/ManageUnlockRequirements.js";
import ManageItems from "./components/ManageItems.js";
import ManageImages from "./components/ManageImages.js";
import ManageAcquisitionMethods from "./components/ManageAcquisitionMethods.js";
import ManageLanguages from "./components/ManageLanguages.js";
import RushHourGame from "./components/RushHourGame.js";
import RushHourSolverPage from "./components/RushHourSolverPage.js";
import SliderSolverPage from "./components/SliderSolverPage.js";
import LootMap from "./components/lootMap.js";

function GetToken() {
  useToken();
  return null;
}

function App() {
  if (window.location.hostname === "shandadapanda.github.io") {
    window.location.replace("https://shandadapanda.com");
  }
  return (
    <div>
      <BrowserRouter>
        <AuthProvider>
          <GetToken />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/items" element={<AllListedItems />} />
            <Route path="/myitems/:gameName" element={<MyItems />} />
            <Route path="/myitems/Cryo" element={<MyItemsCryo />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<CreateAccountForm />} />
            <Route path="/logout" element={<LogoutButton />} />
            <Route path="/item/create" element={<CreateItemForm />} />
            <Route path="/types/create" element={<CreateTypesForm />} />
            <Route path="/event/create" element={<CreateEventForm />} />
            <Route path="/maps/create" element={<CreateMapsForm />} />
            <Route path="/games/create" element={<CreateGamesForm />} />
            <Route path="/mapsname/create" element={<CreateMapsNameForm />} />
            <Route path="/paintings" element={<Paintings />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/paintingSolver" element={<PaintingSolver />} />
            <Route path="/LightsOut" element={<LightsOut />} />
            <Route path="/memory" element={<Grid />} />
            <Route path="/LightsOutSolver" element={<LightsOutSolver />} />
            <Route path="/edit/:itemId" element={<EditItemForm />} />
            <Route path="/SliderGame" element={<SliderGame />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/friends" element={<FriendSearch />} />
            <Route path="/accounts" element={<AllAccounts />} />
            <Route
              path="/edit-account/:accountId"
              element={<AccountSettings />}
            />
            <Route path="/myprofile" element={<MyProfile />} />
            <Route
              path="/edit-my-account/:accountId"
              element={<EditMyAccount />}
            />
            <Route path="/allJunk" element={<AllJunk />} />
            <Route path="/monsters" element={<Monster />} />
            <Route path="/puzzles" element={<Puzzle />} />
            <Route path="/friendlist" element={<FriendList />} />
            <Route path="/statistics" element={<StatsItems />} />
            <Route path="/myitems/LabyrinthineV2" element={<MyItemsV2 />} />
            <Route path="/translations/submit" element={<SubmitTranslations />} />
            <Route path="/translations/review" element={<ReviewTranslations />} />
            <Route path="/suggestions/submit" element={<SubmitSuggestion />} />
            <Route path="/suggestions/review" element={<ReviewSuggestions />} />
            <Route path="/announcements/manage" element={<ManageAnnouncements />} />
            <Route path="/trusted-claimers" element={<TrustedClaimers />} />
            <Route path="/claims/review" element={<ReviewClaims />} />
            <Route path="/unlock-requirements/manage" element={<ManageUnlockRequirements />} />
            <Route path="/items/manage" element={<ManageItems />} />
            <Route path="/images/manage" element={<ManageImages />} />
            <Route path="/acquisition-methods/manage" element={<ManageAcquisitionMethods />} />
            <Route path="/languages/manage" element={<ManageLanguages />} />
            <Route path="/rush-hour/game" element={<RushHourGame />} />
            <Route path="/rush-hour/solver" element={<RushHourSolverPage />} />
            <Route path="/slider/solver" element={<SliderSolverPage />} />
            <Route path="/lootmap/:gameName" element={<LootMap />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
